// VFX: Social Handle Pill
// Category: social-handles · Tags: lower-third, social, handle, pill, instagram
// Pill arredondada com ícone de plataforma + @handle. Spring pop-in.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring } from "remotion";
import React from "react";

const PLATFORM_COLORS: Record<string, string> = {
  instagram: "#e1306c",
  tiktok: "#69c9d0",
  youtube: "#ff0000",
  twitter: "#1da1f2",
};

export interface SocialHandlePillProps {
  platform?: string;
  handle?: string;
  name?: string;
}

export default function SocialHandlePill({ platform = "instagram", handle = "@usuario", name = "Nome" }: SocialHandlePillProps) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const sp = spring({ frame, fps, config: { stiffness: 320, damping: 22, overshootClamping: false } });
  const color = PLATFORM_COLORS[platform] || "#60a5fa";
  const icon = platform === "instagram" ? "IG" : platform === "tiktok" ? "TT" : platform === "youtube" ? "YT" : "@";
  return (
    <AbsoluteFill style={{ justifyContent: "flex-end", alignItems: "flex-start", padding: "0 0 220px 80px", background: "transparent" }}>
      <div style={{
        display: "flex", alignItems: "center", gap: 14,
        background: "rgba(0,0,0,0.78)", backdropFilter: "blur(12px)",
        borderRadius: 100, padding: "12px 28px 12px 14px",
        border: `1.5px solid ${color}80`,
        transform: `scale(${sp}) translateY(${(1 - sp) * 20}px)`,
        opacity: sp,
      }}>
        <div style={{ width: 44, height: 44, borderRadius: 100, background: color, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span style={{ color: "#fff", fontSize: 18, fontWeight: 800 }}>{icon}</span>
        </div>
        <div>
          <p style={{ margin: 0, fontSize: 18, fontWeight: 800, color: "#fff", fontFamily: "system-ui" }}>{name}</p>
          <p style={{ margin: 0, fontSize: 14, color, fontWeight: 700, fontFamily: "system-ui" }}>{handle}</p>
        </div>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
